import React from 'react';
import { EventEmitter } from 'events';


const emitter = new EventEmitter();


export type LocalFeatureFlag =
  'PROVIDER_WELCOME_MODAL_SHOW_GET_READY_BUTTON';

const flags: Partial<Record<LocalFeatureFlag, boolean>> = {};

(window as any).updateLocalFeatureFlag = (key: LocalFeatureFlag, newValue: boolean) => {
  flags[key] = newValue;
  emitter.emit(key);
};

export const useLocalFeatureFlag = (flag: LocalFeatureFlag) => {
  const [ _state, setState ] = React.useState(0);

  React.useEffect(() => {
    const listener = () => {
      setState(Date.now());
    };

    emitter.on(flag, listener);
    return () => {
      emitter.off(flag, listener);
    };
  }, [ flag ]);
  return flags[flag] || false;
};
